import { render, staticRenderFns } from "./workloads-summary.vue?vue&type=template&id=59fc0702&scoped=true&"
import script from "./workloads-summary.vue?vue&type=script&lang=js&"
export * from "./workloads-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fc0702",
  null
  
)

export default component.exports